import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import PopupError from './popup-error.vue';
import { reactive, onBeforeUnmount } from 'vue';
import { goToLogin } from '@/utils';
import { useRouter } from 'vue-router';
import { authStore } from '@/stores';
import _ from 'lodash';

export interface CheckExpose {
  start: () => Promise<boolean>;
}


  const __default__ = {
    inheritAttrs: false
  };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose }) {

const popupVisible = reactive({
  login: false,
  email: false,
  address: false,
});

onBeforeUnmount(() => {
  Object.keys(popupVisible).forEach(k => popupVisible[k] = false);
});

const router = useRouter();

function onLogin() {
  popupVisible.login = false;
  goToLogin();
}

function onVerify() {
  popupVisible.email = false;
  router.push({ name: 'mine.memberProfile.edit', query: { type: 'email' } });
}

function navToProfileEdit() {
  popupVisible.address = false;
  router.push({ name: 'mine.memberProfile.edit' });
}

async function start() {
  if (!authStore.isLogin) {
    popupVisible.login = true;
    return false;
  }
  await authStore.tryFetchData();
  const emailVerified = _.get(authStore, 'user.profile.email_verified');
  if (!emailVerified) {
    popupVisible.email = true;
    return false;
  }
  if (!authStore.canParticipateProgram) {
    popupVisible.address = true;
    return false;
  }
  return true;
}

expose<CheckExpose>({
  start,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(PopupError, {
      modelValue: _unref(popupVisible).login,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(popupVisible).login) = $event)),
      title: "로그인 해주세요",
      class: "check-popup"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", { class: "footer-btn-group" }, [
          _createElementVNode("button", {
            class: "footer-btn",
            onClick: onLogin
          }, " 로그인 ")
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(PopupError, {
      modelValue: _unref(popupVisible).email,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(popupVisible).email) = $event)),
      title: "이메일 인증이 필요합니다.",
      class: "check-popup"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", { class: "footer-btn-group" }, [
          _createElementVNode("button", {
            class: "footer-btn",
            onClick: onVerify
          }, " 이메일 인증하기 ")
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(PopupError, {
      modelValue: _unref(popupVisible).address,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(popupVisible).address) = $event)),
      title: "마이페이지에서<br> 주소 및 휴대폰 번호를 확인해주세요",
      class: "check-popup"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", { class: "footer-btn-group" }, [
          _createElementVNode("button", {
            class: "footer-btn",
            onClick: navToProfileEdit
          }, " 확인 ")
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})